import router from './index';
import routeName from './constant';
import store from '@/store';
import { cancelTransaction } from '@/apis/system';

router.beforeEach((to, from, next) => {
    const {
        metaTitle,
        auth,
        code,
    } = to.meta;
    window.document.title = metaTitle;
    const transactionId = store.state.permissions.transactionId;
    const isLogin = store.state.permissions.auth;
    const aplCatl = store.state.services.aplCatl;

    const keepAuthList = [
        routeName.NOTFOUND,
        routeName.HOME,
        routeName.CLOUD_E_COUNTER_HOME,
    ];
    const keepAuthListIndex = keepAuthList.findIndex(i => i === to.name);
    if (keepAuthListIndex > -1) {
        store.dispatch('services/resetService');
        store.dispatch('policy/resetPolicy');
    }
    if (transactionId !== '' && transactionId) {
        const cancelTransactionPage = [
            routeName.HOME,
            routeName.RECORD,
            routeName.LOGOUT,
            routeName.NO_AUTH,
            routeName.ANNOUNCEMENT,
            routeName.NOTFOUND,
            routeName.CLOUD_E_COUNTER_HOME,
        ];
        const cancelIndex = cancelTransactionPage.findIndex(i => i === to.name);
        if (cancelIndex > -1 && aplCatl) {
            cancelTransaction();
        }
    }
    if (isLogin !== 'Y') {
        if (auth) {
            sessionStorage.clear();
            router.push({ name: routeName.NO_AUTH });
        } else {
            next();
        }
    } else {
        const noAuthPage = [
            routeName.LOGOUT,
            routeName.NO_AUTH,
        ];
        if (to.name === routeName.HOME || to.name === routeName.CLOUD_E_COUNTER_HOME) {
            store.dispatch('permissions/resetTransactionId');
        }
        const index = noAuthPage.findIndex(i => i === to.name);
        if (index > -1) {
            if (store.state.permissions.userInfo.system === 'CEC') {
                next({ name: routeName.CLOUD_E_COUNTER_HOME });
            } else {
                next({ name: routeName.HOME });
            }
        } else if (code) {
            const serviceList = store.state.services.serviceList;

            if (serviceList.length === 0) {
                if (store.state.permissions.userInfo.system === 'CEC') {
                    next({ name: routeName.CLOUD_E_COUNTER_HOME });
                } else {
                    next({ name: routeName.HOME });
                }
            } else {
                const index = serviceList.findIndex(i => i.transactionItemNo === code);
                if (index === -1) {
                    if (store.state.permissions.userInfo.system === 'CEC') {
                        next({ name: routeName.CLOUD_E_COUNTER_HOME });
                    } else {
                        next({ name: routeName.HOME });
                    }
                } else {
                    if (index === 0) {
                        next();
                    } else {
                        const storeCodeList = Object.keys(store.state.services.changeItemsResult);
                        const storeIndex = storeCodeList.findIndex(i => i === serviceList[index - 1].transactionItemNo);
                        if (storeIndex > -1) {
                            next();
                        } else {
                            if (store.state.permissions.userInfo.system === 'CEC') {
                                next({ name: routeName.CLOUD_E_COUNTER_HOME });
                            } else {
                                next({ name: routeName.HOME });
                            }
                        }
                    }
                }
            }
        } else {
            const applyPath = to.fullPath.includes('/apply/');
            if (applyPath && !aplCatl) {
                next({ name: routeName.HOME });
            } else {
                next();
            }
        }
    }
});

router.afterEach(() => {
});

export default router;
